import Holdings from './Holdings'

export default Holdings
